import { render, staticRenderFns } from "./DistrictCard.vue?vue&type=template&id=63bec9d7&scoped=true&"
import script from "./DistrictCard.vue?vue&type=script&lang=js&"
export * from "./DistrictCard.vue?vue&type=script&lang=js&"
import style0 from "./DistrictCard.vue?vue&type=style&index=0&id=63bec9d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bec9d7",
  null
  
)

component.options.__file = "DistrictCard.vue"
export default component.exports